// extracted by mini-css-extract-plugin
module.exports = {"declaration":"dk2Uyy-oX5iTtcx3--s0GQ==","footer":"kg3Yweyj1YypzOIjtRHldA=="};